import { render, staticRenderFns } from "./LRForm.vue?vue&type=template&id=a2165194&scoped=true&"
import script from "./LRForm.vue?vue&type=script&lang=js&"
export * from "./LRForm.vue?vue&type=script&lang=js&"
import style0 from "./LRForm.vue?vue&type=style&index=0&id=a2165194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2165194",
  null
  
)

export default component.exports